import { ListingDesignItem } from "@/features/plp/domain/models/ProductListing";
import { parsePrice } from "@/shared/utils/priceFormatter";

export const HOME_PAGE_PLP_PRODUCT_CLICKED = 'Product Clicked';
export const HOME_PAGE_PLP_ADDED_TO_WISHLIST = 'Added to Wishlist';
export const HOME_PAGE_PLP_ADDED_TO_VIDEO_CALL_CART = 'Added to Video Call Cart';
export const HOME_PAGE_PLP_PRODUCT_VIEWED = 'Product Viewed';

export function getHomePlpProductClick(
  product: ListingDesignItem,
  scrollDepth?: number,
  horizontalPosition?: number
): Record<string, string | number> {
  return {
    'Product Id': product.designId ? String(product.designId) : '',
    'Product Name': product.designName || '',
    'Category Name': product.categoryType || '',
    'MRP': product.price ? parsePrice(product.price) : 0,
    'Selling Price': product.discountedPrice ? parsePrice(product.discountedPrice) : 0,
    'Discount Price': product.discountValue ? parsePrice(product.discountValue) : 0,
    'Discount Percent': product.discountPercent ? parsePrice(String(product.discountPercent)) : 0,
    'Currency': 'INR',
    ...(scrollDepth !== undefined ? { 'Scroll depth': scrollDepth } : {}),
    ...(horizontalPosition !== undefined ? { 'Horizontal position': horizontalPosition } : {}),
    'Offer Name': product.discountName || '',
  };
}

export function getHomePlpAddedToWishlist(
  product: ListingDesignItem
): Record<string, string | number> {
  return {
    'Product Id': String(product.designId),
    'Product Name': product.designName,
    'Category Name': product.categoryType ?? '',
    'Color': product.metal ?? '',
    'MRP': parsePrice(product.price),
    'Selling Price': parsePrice(product.discountedPrice ?? product.price),
    'Discount': parsePrice(product.discountValue),
    'Offer Name': product.discountName ?? '',
    'Currency': 'INR',
  };
}

export function getHomePlpAddedToVideoCallCart(
  product: ListingDesignItem,
  errorMsg?: string
): Record<string, string | number> {
  return {
    'Product Id': String(product.designId),
    'Product Name': product.designName,
    'Category Name': product.categoryType ?? '',
    'Color': product.metal ?? '',
    'MRP': parsePrice(product.price),
    'Selling Price': parsePrice(product.discountedPrice ?? product.price),
    'Discount': parsePrice(product.discountValue),
    'Offer Name': product.discountName ?? '',
    'Currency': 'INR',
    'Error Flag': errorMsg || '',
  };
}

export function getHomePlpProductViewed(
  product: ListingDesignItem,
  scrollDepth: number,
  horizontalPosition: number
): Record<string, string | number> {
  return {
    'Product Id': product.designId ? String(product.designId) : '',
    'Product Name': product.designName || '',
    'Category Name': product.categoryType || '',
    'MRP': product.price ? parsePrice(product.price) : 0,
    'Selling Price': product.discountedPrice ? parsePrice(product.discountedPrice) : 0,
    'Discount Price': product.discountValue ? parsePrice(product.discountValue) : 0,
    'Discount Percent': product.discountPercent ? parsePrice(String(product.discountPercent)) : 0,
    'Currency': 'INR',
    'Scroll depth': scrollDepth,
    'Horizontal position': horizontalPosition,
    'Offer Name': product.discountName || '',
  };
}